Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.queue = exports.supported = exports.version = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _package = require('../package.json');

Object.defineProperty(exports, 'version', {
  enumerable: true,
  get: function get() {
    return _package.version;
  }
});

var _ployfillRequestIdleCallback = require('./ployfill-request-idle-callback');

var CSR_SUPPORT = (typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object';

var supported = exports.supported = CSR_SUPPORT && typeof window.requestIdleCallback === 'function';

var queue = exports.queue = function queue(callback) {
  if (!CSR_SUPPORT) {
    return;
  }

  return window.requestIdleCallback(callback);
};

if (CSR_SUPPORT && !supported) {
  window.requestIdleCallback = _ployfillRequestIdleCallback.requestIdleCallbackFallback;
  window.cancelIdleCallback = _ployfillRequestIdleCallback.cancelIdleCallbackFallback;
}